import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  configurationItems: [],
  configurationItemsAreLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ALL_CONFIGURATION_ITEMS[REQUEST]:
      return { ...state, configurationItemsAreLoaded: false };
    case ActionTypes.GET_ALL_CONFIGURATION_ITEMS[SUCCESS]:
      return { ...state, configurationItems: action.data, configurationItemsAreLoaded: true };
    case ActionTypes.GET_ALL_CONFIGURATION_ITEMS[FAILURE]:
      return { ...state, error: action.error, configurationItemsAreLoaded: false };
    default:
      return state;
  }
};

export default reducer;
